import dayjs from "dayjs";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import useAppDispatch from "hooks/useAppDispatch";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { BEDWETTING_TYPE_VALUE, CHART_LEGENDS_ICON } from "../constants";
import Table from "./grap-table";
import "./styles.scss";
import SelectComponent from "components/select/Select";
import ButtonComponent from "components/button/Button";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Loading from "components/loading/Loading";
import moment from "moment";
import DatePickerComponent from "components/datepicker/Datepicker";
import { CaretDownOutlined } from "@ant-design/icons";
import { Col } from "antd";

require("highcharts/modules/exporting.js")(Highcharts);
require("highcharts/modules/export-data.js")(Highcharts);

const Y_LABEL = {
  0: "9:00",
  1: "8:00",
  2: "7:00",
  3: "6:00",
  4: "5:00",
  5: "4:00",
  6: "3:00",
  7: "2:00",
  8: "1:00",
  9: "0:00",
  10: "23:00",
  11: "22:00",
  12: "21:00",
  13: "20:00",
  14: "19:00",
  15: "18:00",
};

const Y_LABEL_TO_HOUR = {
  9: 0,
  8: 1,
  7: 2,
  6: 3,
  5: 4,
  4: 5,
  3: 6,
  2: 7,
  1: 8,
  0: 9,
  23: 10,
  22: 11,
  21: 12,
  20: 13,
  19: 14,
  18: 15,
};

const calcTimeValue = (time, needConvertUTC, zoneId) => {
  if (time) {
    const targetZone = zoneId || dayjs.tz.guess();
    const dateTime = dayjs.utc(time).tz(targetZone);

    const hour = dateTime.hour();
    const minute = dateTime.minute();

    // console.log(Y_LABEL_TO_HOUR[`${hour}`], hour, dateTime.format(), time);


    return Y_LABEL_TO_HOUR[`${hour}`] || Y_LABEL_TO_HOUR[`${hour}`] === 0
      ? Y_LABEL_TO_HOUR[`${hour}`] - minute / 60
      : null;
  }

  return null;
};

// Highcharts.wrap(Highcharts.Series.prototype, "drawPoints", function (p) {
//   const options = this.options;
//   const symbolCallback = options.marker && options.marker.symbolCallback;
//   const points = this.points;

//   if (symbolCallback && points.length) {
//     points.forEach((point) => {
//       const symbol = symbolCallback.call(point);
//       if (symbol) {
//         point.update(
//           {
//             marker: {
//               symbol: symbol,
//               width: "20px",
//               height: "20px",
//             },
//           },
//           false
//         );
//       }
//     });
//   }

//   p.call(this);
// });

const ChartBedwetting = ({ patientId, treatmentDate }) => {
  const searchParams = new URLSearchParams(window.location.search);
  const zoneIdFromUrl = searchParams.get('zoneId') || dayjs.tz.guess();
  const [width, setWidth] = useState(0);
  const { t } = useTranslation();
  const [chartData, setChartData] = useState({
    wakeUpTime: [],
    toiletTime: [],
    sleepTime: [],
    bedwettingTime: [],
    waterBeforeSleep: [],
    waterAfterSleep: [],
    urineNight: [],
    urineWakeup: [],
  });

  const [exportType, setExportType] = useState(0);
  const printRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [monthSelected, setMonthSelected] = useState(new Date());
  const dateSelectedFirst = dayjs();
  const [dateSelected, setDateSelected] = useState(dayjs());
  const daysInMonth = dateSelected.daysInMonth();

  const TABLE_ROWS = {
    dayNumber: {
      title: "日数",
      data: [...new Array(daysInMonth)].map((_, idx) => idx + 1),
    },
    day: {
      title: "日付",
      data: [...new Array(daysInMonth)].map((_, idx) => idx + 1),
    },
    sleepTime: {
      title: "就寝時間",
      data: [],
    },
    isBedWetting: {
      title: "夜尿結果",
      data: [],
    },
    bedwettingTime: {
      title: "夜尿時間",
      data: [],
    },
    urineNight: {
      title: "夜尿量",
      data: [],
      bgColor: "#c6e0b4",
    },
    toiletTime: {
      title: "トイレの時間",
      data: [],
    },
    wakeUpTime: {
      title: "起床時間",
      data: [],
    },
    urineWakeup: {
      title: "起床後尿量",
      data: [],
      bgColor: "#fcf",
    },
    totalUrine: {
      title: "夜尿量+起床後尿量",
      data: [],
    },
    waterBeforeSleep: {
      title: "就寝前水分量",
      data: [],
      bgColor: "#ccf",
    },
    waterAfterSleep: {
      title: "夜中水分量",
      data: [],
      bgColor: "#ff9",
    },
  };

  const [tableData, setTableData] = useState(TABLE_ROWS);

  const categories = [...new Array(daysInMonth)].map((item, idx) => ({
    category: ` ${idx + 1}`,
    value: idx + 1,
  }));

  const {
    data: {
      graphUrine: { data },
    },
    actions: { actGetGraphUrine },
  } = useAppDispatch("graph");

  const chartDataWithDay = data?.reduce((acc, current) => {
    const dateTime = new Date(current?.time);
    const date = dateTime.getDate();
    acc[date] = current;
    return acc;
  }, {});


  useEffect(() => {
    if (patientId) {
      actGetGraphUrine({
        id: patientId,
        params: {
          from: dayjs(dateSelected)
            .startOf("month")
            .startOf("day")
            .utc()
            .format("YYYY-MM-DD HH:mm"),
          to: dayjs(dateSelected)
            .endOf("month")
            .endOf("day")
            .utc()
            .format("YYYY-MM-DD HH:mm"),
        },
      });
    }

    const handleResize = () => {
      window.location.reload();
    };

    window.addEventListener('resize', handleResize);

    // return () => window.removeEventListener('resize', handleResize);
  }, []);



  useEffect(() => {
    if (patientId) {
      const date = dayjs();
      const endDayNowSelected = dayjs(date).endOf("month").endOf("day")
      const endDaySelected = dayjs(monthSelected).endOf("month").endOf("day")
      if (endDaySelected.isBefore(date)) {
        setDateSelected(endDaySelected)
      } else if (endDayNowSelected.isSame(endDaySelected)) {
        setDateSelected(dayjs())
      } else {
        setDateSelected(dayjs(monthSelected).startOf("month").startOf("day"))
      }

      actGetGraphUrine({
        id: patientId,
        params: {
          from: dayjs(monthSelected)
            .startOf("month")
            .startOf("day")
            .utc()
            .format("YYYY-MM-DD HH:mm"),
          to: dayjs(monthSelected)
            .endOf("month")
            .endOf("day")
            .utc()
            .format("YYYY-MM-DD HH:mm"),
        },
      });
    }
  }, [monthSelected])

  const vwToPx = (vw) => window.innerWidth * (vw / 100);

  useEffect(() => {
    if (data) {
      const dataFormat = categories?.reduce(
        (acc, current) => {
          const currentData = chartDataWithDay[current.value] || {};
          const wakeUpTime = calcTimeValue(currentData.wakeup_time || currentData.wakeup_time_sensor, true, zoneIdFromUrl);
          const toiletTime = calcTimeValue(currentData.memo_time || currentData.memo_time_sensor, true, zoneIdFromUrl);
          if (currentData.memo_time || currentData.memo_time_sensor) {
            console.log('toiletTime', currentData.memo_time, currentData.memo_time_sensor, currentData.memo_time || currentData.memo_time_sensor);
          }

          const sleepTime = calcTimeValue(currentData.sleep_time || currentData.sleep_time_sensor, true, zoneIdFromUrl);
          const bedwettingTime = calcTimeValue(currentData.bed_wetting_time || currentData.bed_wetting_time_sensor, true, zoneIdFromUrl);

          const waterBeforeSleep = currentData.amount_water_before_bed || 0;
          const waterAfterSleep = currentData.amount_water_after_bed || 0;
          const urineNight = currentData.bed_wetting_amount || 0;
          const urineWakeup = currentData.urine_amount || 0;
          const isBedWetting = currentData.is_bed_wetting;
          const totalUrine = urineNight + urineWakeup;

          if (wakeUpTime) {
            // console.log('wakeUpTime', currentData.time, wakeUpTime, currentData.wakeup_time || currentData.wakeup_time_sensor);
            acc.wakeUpTime.push({
              x: current.value - 1,
              y: wakeUpTime,
              marker: {
                symbol: `url(${CHART_LEGENDS_ICON.wakeUpTime})`,
                width: vwToPx(1.5),
                height: vwToPx(1.5),
                marginRight: '1vw',
                marginBottom: '1vw',
              },
            });
          }
          if (toiletTime) {
            acc.toiletTime.push({
              x: current.value - 1,
              y: toiletTime,
              marker: {
                symbol: `url(${CHART_LEGENDS_ICON.toiletTime})`,
                width: vwToPx(1.5),
                height: vwToPx(1.5),
              },
            });
          }

          if (sleepTime) {
            acc.sleepTime.push({
              x: current.value - 1,
              y: sleepTime,
              marker: {
                symbol: `url(${CHART_LEGENDS_ICON.sleepTime})`,
                width: vwToPx(1.5),
                height: vwToPx(1.5),
              },
            });
          }

          if (bedwettingTime) {

            let bedIcon = ''

            if (
              currentData.bed_wetting_type ===
              BEDWETTING_TYPE_VALUE
                .the_alarm_went_off_and_I_woke_up_to_stop_it.value
            ) {
              bedIcon = currentData.is_bed_wetting_to_toilet
                ? `url(${CHART_LEGENDS_ICON.waterDotBluer})`
                : `url(${CHART_LEGENDS_ICON.waterBluer})`;
            }

            if (
              currentData.bed_wetting_type ===
              BEDWETTING_TYPE_VALUE
                .the_alarm_went_off_but_I_couldnt_wake_up_by_myself.value
            ) {
              bedIcon = currentData.is_bed_wetting_to_toilet
                ? `url(${CHART_LEGENDS_ICON.waterDot})`
                : `url(${CHART_LEGENDS_ICON.water})`;
            }

            acc.bedwettingTime.push({
              x: current.value - 1,
              y: bedwettingTime,
              marker: {
                symbol: bedIcon,
                width: vwToPx(1.5),
                height: vwToPx(1.5),
              },
            });
          }



          acc.wakeUpTimeTable.push(currentData.wakeup_time || currentData.wakeup_time_sensor ? dayjs.utc(currentData.wakeup_time || currentData.wakeup_time_sensor).tz(zoneIdFromUrl) : null);
          const isGoToToiletOnly = !(currentData?.is_bed_wetting ?? false) && (currentData.is_bed_wetting_to_toilet ?? false);
          const rawToiletTime = isGoToToiletOnly
            ? (currentData?.bed_wetting_time || currentData?.bed_wetting_time_sensor)
            : (currentData?.memo_time || currentData?.memo_time_sensor);

          acc.toiletTimeTable.push(rawToiletTime ? dayjs.utc(rawToiletTime).tz(zoneIdFromUrl) : null);
          acc.sleepTimeTable.push(currentData.sleep_time || currentData.sleep_time_sensor ? dayjs.utc(currentData.sleep_time || currentData.sleep_time_sensor).tz(zoneIdFromUrl) : null);
          acc.bedwettingTimeTable.push(currentData.bed_wetting_time || currentData.bed_wetting_time_sensor ? dayjs.utc(currentData.bed_wetting_time || currentData.bed_wetting_time_sensor).tz(zoneIdFromUrl) : null);

          // acc.wakeUpTimeTable.push(currentData.wakeup_time || currentData.wakeup_time_sensor);
          // // acc.toiletTimeTable.push(!(((currentData?.is_bed_wetting ?? false) && (currentData.is_bed_wetting_to_toilet ?? false))) ? (currentData?.memo_time || currentData?.memo_time_sensor) : (currentData?.bed_wetting_time || currentData?.bed_wetting_time_sensor));
          // acc.sleepTimeTable.push(currentData.sleep_time || currentData.sleep_time_sensor);
          // // acc.toiletTimeTable.push(!(((currentData?.is_bed_wetting ?? false) && (currentData.is_bed_wetting_to_toilet ?? false))) ? (currentData?.memo_time || currentData?.memo_time_sensor) : (currentData?.bed_wetting_time || currentData?.bed_wetting_time_sensor));
          // // == CRITICAL CHANGE ==
          // if (!((currentData.is_bed_wetting_to_toilet ?? false))) {
          //   // acc.bedwettingTimeTable.push(currentData.bed_wetting_time || currentData.bed_wetting_time_sensor);
          //   acc.toiletTimeTable.push(currentData.memo_time || currentData.memo_time_sensor);
          // } else {
          //   // acc.toiletTimeTable.push(currentData.memo_time || currentData.memo_time_sensor);
          //   // acc.toiletTimeTable.push(currentData.bed_wetting_time || currentData.bed_wetting_time_sensor);
          //   // acc.bedwettingTimeTable.push(currentData.bed_wetting_time || currentData.bed_wetting_time_sensor);
          // }
          // // == CRITICAL CHANGE ==
          // if (!((currentData?.is_bed_wetting ?? false) && (currentData.is_bed_wetting_to_toilet ?? false))) {
          //   acc.bedwettingTimeTable.push(currentData.bed_wetting_time || currentData.bed_wetting_time_sensor);
          // }

          acc.waterBeforeSleep.push(waterBeforeSleep);
          acc.waterAfterSleep.push(waterAfterSleep);
          acc.urineNight.push(urineNight);
          acc.urineWakeup.push(urineWakeup);

          acc.isBedWetting.push(isBedWetting);
          acc.totalUrine.push(totalUrine);

          acc.mappingTime.sleepTime[sleepTime] = currentData.sleep_time || currentData.sleep_time_sensor;
          acc.mappingTime.bedwettingTime[bedwettingTime] =
            currentData.bed_wetting_time || currentData.bed_wetting_time_sensor;
          acc.mappingTime.toiletTime[toiletTime] = currentData.memo_time || currentData.memo_time_sensor;
          acc.mappingTime.wakeUpTime[wakeUpTime] = currentData.wakeup_time || currentData.wakeup_time_sensor;

          return acc;
        },
        {
          wakeUpTime: [],
          toiletTime: [],
          sleepTime: [],
          bedwettingTime: [],
          waterBeforeSleep: [],
          waterAfterSleep: [],
          urineNight: [],
          urineWakeup: [],
          isBedWetting: [],
          totalUrine: [],
          wakeUpTimeTable: [],
          toiletTimeTable: [],
          sleepTimeTable: [],
          bedwettingTimeTable: [],
          mappingTime: {
            sleepTime: {},
            bedwettingTime: {},
            toiletTime: {},
            wakeUpTime: {},
          },
        }
      );

      setChartData(dataFormat);

      setTableData((item) => {
        item.sleepTime.data = dataFormat.sleepTimeTable;
        item.bedwettingTime.data = dataFormat.bedwettingTimeTable;
        item.toiletTime.data = dataFormat.toiletTimeTable;
        item.wakeUpTime.data = dataFormat.wakeUpTimeTable;

        item.isBedWetting.data = dataFormat.isBedWetting;
        item.urineNight.data = dataFormat.urineNight;

        item.urineWakeup.data = dataFormat.urineWakeup;
        item.totalUrine.data = dataFormat.totalUrine;
        item.waterBeforeSleep.data = dataFormat.waterBeforeSleep;
        item.waterAfterSleep.data = dataFormat.waterAfterSleep;

        return item;
      });
    }
  }, [data, zoneIdFromUrl, daysInMonth]);

  const options = {
    title: {
      text: "",
    },
    chart: {
      type: "column",
      animation: false,
      height: 450,
      margin: [0, 50, 0, 56],
      events: {
        render: function (ev) {
          const chart = ev.target;
          const widthPlot = chart.plotWidth / daysInMonth - 1;
          setWidth(widthPlot);

          if (chart.customLines) {
            chart.customLines.forEach(line => line.destroy());
          }
          chart.customLines = [];
          const yAxis = chart.yAxis[0];
          for (let i = 0; i <= 15; i++) {
            const y = yAxis.toPixels(i);
            chart.customLines.push(chart.renderer.path([
              'M', chart.plotLeft, y,
              'L', chart.plotLeft + chart.plotWidth, y
            ]).attr({
              'stroke': '#b0b0b0',
              'stroke-width': 0.8,
              'zIndex': 1
            }).add());
          }
          for (let i = 0; i < 15; i++) {
            const y = yAxis.toPixels(i + 0.5);
            chart.customLines.push(chart.renderer.path([
              'M', chart.plotLeft, y,
              'L', chart.plotLeft + chart.plotWidth, y
            ]).attr({
              'stroke': '#c0c0c0',
              'stroke-width': 0.5,
              'stroke-dasharray': '4,3',
              'zIndex': 1
            }).add());
          }
        },
      },
    },
    series: [
      {
        color: "#ff9",
        name: "waterAfterSleep",
        data: chartData?.waterAfterSleep || [],
        stack: "water",
        yAxis: "yAxis-urine",
        pointWidth: 15,
        tooltip: {
          pointFormatter: function () {
            return `${TABLE_ROWS[this.series.name].title} - ${this.y}`;
          },
        },
      },
      {
        color: "#ccf",
        name: "waterBeforeSleep",
        data:
          chartData?.waterBeforeSleep?.length >= daysInMonth
            ? chartData?.waterBeforeSleep?.slice(0, daysInMonth)
            : [
              ...chartData?.waterBeforeSleep,
              ...Array(daysInMonth - chartData?.waterBeforeSleep.length),
            ],
        stack: "water",
        yAxis: "yAxis-urine",
        pointWidth: 15,
        tooltip: {
          pointFormatter: function () {
            return `${TABLE_ROWS[this.series.name].title} - ${this.y}`;
          },
        },
      },
      {
        color: "#c6e0b4",
        name: "urineNight",
        data: chartData?.urineNight || [],
        stack: "urine",
        yAxis: "yAxis-urine",
        pointWidth: 15,
        tooltip: {
          pointFormatter: function () {
            return `${TABLE_ROWS[this.series.name].title} - ${this.y}`;
          },
        },
      },
      {
        color: "#fcf",
        name: "urineWakeup",
        data: chartData?.urineWakeup || [],
        stack: "urine",
        yAxis: "yAxis-urine",
        pointWidth: 15,
        tooltip: {
          pointFormatter: function () {
            return `${TABLE_ROWS[this.series.name].title} - ${this.y}`;
          },
        },
      },
      /// Line
      {
        type: "line",
        color: "#f9d76e",
        data: chartData?.wakeUpTime || [],
        name: "wakeupTime",
        yAxis: "yAxis-time",
        // marker: {
        //   symbol: `url(${CHART_LEGENDS_ICON.wakeUpTime})`,
        //   width: "20px",
        //   height: "20px",
        // },
        tooltip: {
          pointFormatter: function () {
            const time = chartData.mappingTime.wakeUpTime[this.y];
            return dayjs(time).format("HH:mm");
          },
        },
      },
      {
        type: "line",
        color: "#434466",
        data: chartData?.toiletTime || [],
        name: "toiletTime",
        lineWidth: 0,
        yAxis: "yAxis-time",
        // marker: {
        //   symbol: `url(${CHART_LEGENDS_ICON.toiletTime})`,
        //   width: "20px",
        //   height: "20px",
        // },
        tooltip: {
          pointFormatter: function () {
            const time = chartData.mappingTime.toiletTime[this.y];
            return dayjs(time).format("HH:mm");
          },
        },
      },
      {
        type: "line",
        color: "#5692d1",
        data: chartData?.bedwettingTime || [],
        name: "bedwettingTime",
        yAxis: "yAxis-time",
        // marker: {
        //   symbolCallback: function (point) {
        //     const pointData = chartDataWithDay[this.x + 1];
        //     let icon = ``;

        //     if (pointData) {
        //       if (
        //         pointData.bed_wetting_type ===
        //         BEDWETTING_TYPE_VALUE
        //           .the_alarm_went_off_and_I_woke_up_to_stop_it.value
        //       ) {
        //         icon = pointData.is_bed_wetting_to_toilet
        //           ? `url(${CHART_LEGENDS_ICON.waterDotBluer})`
        //           : `url(${CHART_LEGENDS_ICON.waterBluer})`;
        //       }

        //       if (
        //         pointData.bed_wetting_type ===
        //         BEDWETTING_TYPE_VALUE
        //           .the_alarm_went_off_but_I_couldnt_wake_up_by_myself.value
        //       ) {
        //         icon = pointData.is_bed_wetting_to_toilet
        //           ? `url(${CHART_LEGENDS_ICON.waterDot})`
        //           : `url(${CHART_LEGENDS_ICON.water})`;
        //       }
        //     }

        //     return icon;
        //   },
        // },
        tooltip: {
          pointFormatter: function () {
            const time = chartData.mappingTime.bedwettingTime[this.y];
            return dayjs(time).format("HH:mm");
          },
        },
      },
      {
        type: "line",
        color: "#ffcb2d",
        data: chartData?.sleepTime || [],
        name: "sleepTime",
        yAxis: "yAxis-time",
        // marker: {
        //   symbol: `url(${CHART_LEGENDS_ICON.sleepTime})`,
        //   width: "20px",
        //   height: "20px",
        // },
        tooltip: {
          pointFormatter: function () {
            const time = chartData.mappingTime.sleepTime[this.y];
            return dayjs(time).format("HH:mm");
          },
        },
      },
    ],
    xAxis: {
      categories: categories.map((x) => x.category),
      labels: {
        step: 1,
        enabled: false,
      },
      breaks: [
        {
          breakSize: 1,
        },
      ],
      gridLineWidth: 1,
      gridLineColor: "#4472c4",
      pointStart: 1,
    },
    yAxis: [
      {
        id: "yAxis-time",
        lineColor: "black",
        lineWidth: 2,
        categories: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        title: {
          text: ``,
          useHtml: true,
          style: {
            // fontSize: 16
          },
        },
        breaks: [
          {
            breakSize: 1,
          },
        ],
        labels: {
          step: 1,
          formatter: function () {
            var time = this.value;

            return Y_LABEL[time];
          },
        },

        gridLineWidth: 0,
        max: 15,
        min: 0,
      },
      {
        id: "yAxis-urine",
        title: {
          text: "",
          style: {
            fontSize: 16,
          },
        },
        tickWidth: 1,
        tickLength: 0,
        opposite: true,

        lineWidth: 2,
        min: 0,
        max: 1000,
        tickPositions: [0, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
        breaks: [
          {
            breakSize: 100,
          },
        ],
        labels: {
          format: "{value}",
          y: -3,
          x: 5
        },
        gridLineWidth: 0,
      },
    ],
    legend: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    plotOptions: {
      column: {
        stacking: "normal",
      },
      series: {
        // enableMouseTracking: false,
        // states: {
        //     hover: {
        //         enabled: false
        //     }
        // },
      },
    },
    credits: {
      enabled: false,
    },
  };

  const EXPORT_OPTIONS_VALUE = {
    PDF: 0,
    CSV_MANUAL: 1,
    CSV_AUTO: 2,
  };

  const exportOption = [
    {
      label: t("graph.bedwetting"),
      value: EXPORT_OPTIONS_VALUE.PDF,
      prefix: "/icons/pdf.webp",
    }
  ];

  return (
    <div>
      <div style={{ height: "890px" }} ref={printRef}>
        <Col span={4} style={{ zIndex: 10 }}>
          <DatePickerComponent
            suffixIcon={
              <CaretDownOutlined
                style={{ fontSize: "20px", color: "#737373" }}
              />
            }
            placeholder={"YYYY-MM"}
            format="YYYY-MM"
            name="date"
            dateFormat={"yyyy/MM"}
            showMonthYearPicker={true}
            value={monthSelected}
            // error={errors?.date}
            onChange={(e) => setMonthSelected(e)}
          />
        </Col>
        <div className="chart-bedwetting-container">
          <div className="urine-chart-time">
            {dateSelected.format(t("graph.chartTime"))}
          </div>
          <div className="chart-session">
            <div className="yaxis-title">
              <div className="title-pm">PM</div>
              <div className="title-horizon"></div>
              <div className="title-am">AM</div>
            </div>
            <div className="chart-box">
              <HighchartsReact highcharts={Highcharts}
                options={options}
              />
              <div className="chart-yaxis-1000">1000</div>
            </div>
          </div>
          <Table
            width={width}
            tableData={tableData}
            chartDataWithDay={chartDataWithDay}
            daysInMonth={daysInMonth}
            dateSelected={dateSelected}
            exportOption={exportOption}
            exportType={exportType}
            setExportType={setExportType}
            element={printRef}
            isLoading={isLoading}
            treatmentDate={treatmentDate}
            setIsLoading={setIsLoading}
            patientId={patientId}
          />
        </div>
      </div>
      {isLoading && <Loading />}
    </div>
  );
};

export default ChartBedwetting;
